export default __webpack_public_path__ + "043a79696b507d9d792f430c49047a63.png";